import React, {
  useMemo
} from 'react'


import { Card } from './styles'

type TProps = {
  handleClose: () => void
  handleConfirmation?: () => void
  isModalVisible: boolean,
  title: string
  children: React.ReactChild
  id: string
  hasButtons?: boolean
}

const RelateModal = (props: TProps): JSX.Element => {
  const {
    handleClose,
    handleConfirmation,
    isModalVisible,
    title,
    children,
    hasButtons,
  } = props

  const close = handleClose

  const footer = useMemo(() => hasButtons ? hasButtons : null, [hasButtons])

  return (
    <Card
      transitionName=''
      maskTransitionName=''
      closable
      okText='Salvar'
      footer={footer}
      title={title}
      open={isModalVisible}
      onOk={handleConfirmation}
      onCancel={close}
      cancelText='Cancelar'
      destroyOnClose={true}
    >
      {children}
    </Card>
  )
}

export default RelateModal